import { axiosAuthInstance } from '@config/api';
import { AvatarUpdate } from '@interfaces/avatar';

const UPDATE_AVATAR = '/users/me/update-avatar';
const USER_ACTIVITY = '/users/activity/';

export const updateAvatar = (avatar: AvatarUpdate) => axiosAuthInstance.put(UPDATE_AVATAR, avatar);
export const reportUserActivity = (gameId?: number) =>
  axiosAuthInstance.post(`${USER_ACTIVITY}${gameId || ''}`);
